module.exports = __webpack_public_path__ + "img/cp-11.4c4e4190.jpg";